// メッセージ種別
export enum MessageType {
    Information = 0,    // 情報
    Warning,            // 警告
    Error,              // エラー
}
